module.exports = __webpack_public_path__ + "static/media/1f91d.cd1a8569.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f91d.svg
// module id = 647
// module chunks = 1